/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { seePlansPremiumModalEvent } from '~/functions/events';
import dataPlans from '../../../data/plans.json';

import {
  ContainerGeral,
  Container,
  Div,
  Header,
  Card,
  Price,
  OldPrice,
  DiscountLabel,
  DivButton,
  DivPrice,
} from './styles';

// import CrownIcon from '../../../assets/icons/plan/crown.svg';
import ArrowRight from '../../../assets/icons/arrowRight.svg';
import LockIcon from '../../../assets/icons/popups/lock';

function PremiumPlan({ showModal, Modal, is_desktop, SetIndexMenu }) {
  const history = useHistory();

  const handleModal = useCallback(
    buttonClicked => {
      Modal(false);

      if (buttonClicked) {
        history.push('/pro');
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Modal]
  );

  const handleModalDesktop = useCallback(() => {
    Modal(false, true);
    SetIndexMenu(7);
  }, [Modal, SetIndexMenu]);

  return (
    <ContainerGeral>
      <Container showModal={showModal} onClick={() => handleModal(false)} />
      <Div showModal={showModal}>
        <Header>
          <LockIcon />

          <strong>
            <span>Assine o Plano {dataPlans.premium.name}</span> para ter acesso
            a esse recurso e muito mais!
          </strong>
        </Header>

        <Card>
          <DivPrice>
            <Price color={dataPlans.premium.color}>
              R$ {dataPlans.premium.price.yearly.price}
              <span>/mês</span>
            </Price>
            <OldPrice>
              R$ {dataPlans.premium.price.yearly.oldPrice}/mês
            </OldPrice>
          </DivPrice>

          <DiscountLabel color={dataPlans.premium.color}>
            <span>
              {dataPlans.premium.price.yearly.economyPercent} DE DESCONTO
            </span>
          </DiscountLabel>
        </Card>

        <DivButton>
          {(is_desktop && (
            <button type="button" onClick={handleModalDesktop}>
              Assinar plano {dataPlans.premium.name}{' '}
              <img src={ArrowRight} alt="arrow" />
            </button>
          )) || (
            // <Link to="/pro" onClick={handleModal}>
            //   Assinar plano {dataPlans.premium.name}{' '}
            //   <img src={ArrowRight} alt="arrow" />
            // </Link>
            <button
              type="button"
              onClick={() => {
                seePlansPremiumModalEvent();
                handleModal(true);
              }}
            >
              Assinar plano {dataPlans.premium.name}{' '}
              <img src={ArrowRight} alt="arrow" />
            </button>
          )}
        </DivButton>
      </Div>
    </ContainerGeral>
  );
}

export default PremiumPlan;
